import '../../../../lib/style/index.less';
import '../../../../lib/collapse/style';
import './index.less';
// style dependencies
import '../../form/style';
import '../../output/style';
import '../../button/style';
import '../../radio/style';
import '../../check-box/style';
import '../../text-field/style';
import '../../color-picker/style';
import '../../currency/style';
import '../../number-field/style';
import '../../intl-field/style';
import '../../url-field/style';
import '../../email-field/style';
import '../../lov/style';
import '../../select/style';
import '../../select-box/style';
import '../../tree-select/style';
import '../../date-picker/style';
import '../../spin/style';
import '../../pagination/style';
import '../../modal-container/style';
import '../../tooltip/style';
import '../../validator/style';
import '../../switch/style';
import '../../menu/style';
